export default __webpack_public_path__ + "static/media/bolognese.bc247ca6.png";